<div class="view-section hub-outcomes-container" id="outcomes">
    @if(!isProgramManagement) {

    <h3 class="view-section-header">
        {{ project.projectType.name }} Outcomes
        <span class="text-muted">({{outcomes?.length + customOutcomes?.length }})</span>
        <app-help-selector [selector]="1187"></app-help-selector>
    </h3>

    <div class="details">
        @if (outcomes.length) {

        <h6 class="organizational-metrics-heading">
            2030 Goals Metrics
            <app-help-selector [selector]="1186"></app-help-selector>
        </h6>

        @for (outcome of outcomes; track outcome; let outcomeIndex = $index) {
        <div>
            <app-outcome
                [projectId]="project.projectId"
                [projectOutcome]="outcome"
                [isStrategy]="isStrategy"
                (projectDataAreLoading)="projectDataAreLoading.emit($event)"
                [outcomeIndex]="outcomeIndex"
            ></app-outcome>
        </div>
        } }

        <ng-container>
            @if (customOutcomes?.length) {
            <h6 class="other-sca-metrics-heading">Custom Metrics</h6>

            @for (outcome of customOutcomes; track outcome; let outcomeIndex = $index) {
            <div>
                <!-- CUSTOM OUTCOMES -->
                <app-custom-outcome
                    [projectId]="project.projectId"
                    [projectOutcome]="outcome"
                    [isStrategy]="isStrategy"
                    (projectDataAreLoading)="projectDataAreLoading.emit($event)"
                    [outcomeIndex]="outcomeIndex"
                    [indexOffset]="outcomes.length + 1"
                ></app-custom-outcome>
            </div>
            } }
        </ng-container>

        <!-- SHOW IF NO OUTCOMES DEFINED (That is, there are no outcomes and no custom outcomes) -->
        @if (outcomes?.length === 0 && customOutcomes?.length === 0) {
        <div class="alert alert-info alert-styled-left shadow-0 mr-3">
            This record has not defined any Outcomes yet. Contact the Lead on the record to inquire about Outcomes.
        </div>
        }
    </div>
    }

    @if (isProgramManagement) {
        <app-program-linked-outcomes-panel [project]="project"></app-program-linked-outcomes-panel>
    }
</div>
